import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import MedicationsTable from "../components/tables/medicationsTable";
import MedicationHistorySidebar from "../components/common/MedicationHistorySidebar";

export default function MedicationsHistory({ handleFetchDrugs, drugs, loading }) {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (mode) => {
    if (mode === "dark") {
      const btnWhite = document.getElementsByClassName("btn-white");

      for (const btn of btnWhite) {
        btn.classList.add("btn-outline-primary");
        btn.classList.remove("btn-white");
      }
      return;
    }

    const btnOutlinePrimary = document.getElementsByClassName("btn-outline-primary");

    for (const btn of btnOutlinePrimary) {
      btn.classList.remove("btn-outline-primary");
      btn.classList.add("btn-white");
    }
  };

  switchSkin(skin);
  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  const medicationCount = Array.isArray(drugs?.result) ? drugs.result.length : 0;
  const prescriptionCount = Array.isArray(drugs?.result)
    ? drugs.result.filter((item) => item?.requestType).length
    : 0;

  return (
    <React.Fragment>
      <div className="p-3 p-lg-4">
        <div className="data-page-hero">
          <div className="data-page-copy">
            <span className="data-page-kicker">Medication Records</span>
            <h2>Keep prescriptions and medication history easier to scan</h2>
            <p>
              Review prescriptions, refill information, prescribers, and payment details in a
              calmer record layout.
            </p>
          </div>

          <div className="data-page-stats">
            <div className="data-page-stat">
              <small>Records</small>
              <strong>{medicationCount}</strong>
            </div>
            <div className="data-page-stat">
              <small>Prescriptions</small>
              <strong>{prescriptionCount}</strong>
            </div>
            <div className="data-page-stat">
              <small>Search Ready</small>
              <strong>Live Filter</strong>
            </div>
          </div>
        </div>

        <Row className="g-4">
          <Col xl="9">
            <Card className="data-panel">
              <MedicationsTable
                drugs={drugs}
                handleFetchDrugs={handleFetchDrugs}
                loading={loading}
              />
            </Card>
          </Col>
          <Col xl="3" className="d-none d-xl-block">
            <MedicationHistorySidebar />
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}
